import axios, {
  type AxiosInstance,
  type InternalAxiosRequestConfig,
} from "axios";
import * as Sentry from "@sentry/react";

const baseURL =
  import.meta.env.VITE_API_URL ||
  (import.meta.env.DEV
    ? "http://127.0.0.1:8000/api"
    : "https://indoteknisi.net/api");

const instance: AxiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

instance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.set("Authorization", `Bearer ${token}`);
    }

    return config;
  },
  (error: unknown) => Promise.reject(error),
);

// Interceptor untuk menangkap error response API dan mengirimnya ke Sentry
instance.interceptors.response.use(
  (response) => response,
  (error: any) => {
    // Kirim informasi error ke Sentry sebelum error dilempar kembali
    Sentry.captureException(error, {
      extra: {
        apiUrl: error.config?.url,
        apiMethod: error.config?.method,
        responseStatus: error.response?.status,
        responseData: error.response?.data,
      },
    });

    // Pengecekan jika error response adalah 401 (Unauthorized), maka hapus token dan redirect ke halaman login
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");

      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  },
);

export default instance;
